import { render, staticRenderFns } from "./MainMenu.vue?vue&type=template&id=1d701a6e&scoped=true&"
import script from "./MainMenu.vue?vue&type=script&lang=ts&"
export * from "./MainMenu.vue?vue&type=script&lang=ts&"
import style0 from "./MainMenu.vue?vue&type=style&index=0&id=1d701a6e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d701a6e",
  null
  
)

export default component.exports